import { FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import { SyntheticEvent } from 'react';

import { TextError } from './TextError.comp';

interface Props {
  isDisabled?: boolean;
  label: string;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  onChange: (event: SyntheticEvent<Element, Event>, checked: boolean) => void;
  value: boolean;
}

export const CheckboxFormField: React.FC<Props> = props => {
  const { labelPlacement, value, ...rest } = props;

  return (
    <FormControl>
      <FormControlLabel
        control={<Checkbox sx={{ pt: 1 }} />}
        {...rest}
        checked={value}
        labelPlacement={labelPlacement ?? 'top'}
      />
      <TextError error={undefined} />
    </FormControl>
  );
};
